import { render, staticRenderFns } from "./CartItemGroupList.vue?vue&type=template&id=4dab9c16&scoped=true&"
import script from "./CartItemGroupList.vue?vue&type=script&lang=ts&"
export * from "./CartItemGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab9c16",
  null
  
)

export default component.exports